import logoMultivaBlanco from "@/assets/logo-multiva-blanco.svg";

/**
 * Panel marketing del lado izquierdo de /login · gradiente Multiva con dos
 * orbes decorativos animados, el logotipo oficial en grande al centro y
 * footer con copyright. Solo visible en md+.
 *
 * Polish: textura de grano SVG ultra-sutil sobre el gradiente + orbes con
 * drift lento (`multivaOrbDrift`, ya definido en globals.css, respeta
 * prefers-reduced-motion).
 */
export function LoginMarketingPanel() {
  return (
    <div className="relative hidden h-full overflow-hidden p-8 text-white md:block" style={{ backgroundImage: BACKGROUND }}>
      <OrbeDecorativo className="-right-30 -top-30 size-90" opacidad={0.18} animationDelay="0s" />
      <OrbeDecorativo className="-left-15 -bottom-25 size-70" opacidad={0.1} animationDelay="-4s" />

      <div className="relative z-[1] flex h-full flex-col justify-between">
        <div />
        <div className="multiva-fade-up mx-auto" style={{ width: "min(78%, 520px)" }}>
          <img src={logoMultivaBlanco} alt="Grupo Financiero Multiva" className="block h-auto w-full" />
          {/* La "P" alineada con la "b" de "banco": en el SVG (viewBox 2048) la "b" inicia en x=520.75 → 25.4% del ancho del logotipo. */}
          <p
            className="font-medium leading-none"
            style={{ fontSize: "clamp(18px, 1.8vw, 26px)", letterSpacing: 0.5, opacity: 0.92, marginLeft: "25.4%" }}
          >
            Portal de proveedores
          </p>
        </div>
        <p className="text-xs" style={{ opacity: 0.55 }}>
          © {new Date().getFullYear()} Grupo Financiero Multiva
        </p>
      </div>
    </div>
  );
}

const BACKGROUND = [
  "linear-gradient(135deg, var(--color-multiva-800) 0%, var(--color-multiva-700) 60%, var(--color-multiva-600) 100%)",
  `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/%3E%3CfeColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.10 0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)'/%3E%3C/svg%3E")`,
].join(", ");

/** Orbe radial decorativo · `pointer-events-none` para no interceptar clics. */
function OrbeDecorativo({ className, opacidad, animationDelay }: { className: string; opacidad: number; animationDelay: string }) {
  return (
    <div
      className={`pointer-events-none absolute rounded-full ${className}`}
      style={{
        background: `radial-gradient(circle, rgba(255,255,255,${opacidad}) 0%, transparent 70%)`,
        animation: "multivaOrbDrift 14s ease-in-out infinite",
        animationDelay,
        willChange: "transform",
      }}
    />
  );
}
